var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMonitorPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M26.833 6H6.83301C6.30257 6 5.79387 6.21071 5.41879 6.58579C5.04372 6.96086 4.83301 7.46957 4.83301 8V22C4.83301 22.5304 5.04372 23.0391 5.41879 23.4142C5.79387 23.7893 6.30257 24 6.83301 24H26.833C27.3634 24 27.8721 23.7893 28.2472 23.4142C28.6223 23.0391 28.833 22.5304 28.833 22V8C28.833 7.46957 28.6223 6.96086 28.2472 6.58579C27.8721 6.21071 27.3634 6 26.833 6ZM14.833 19V11L20.833 15L14.833 19Z",
    fill: "#E85D04"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.83301 24L26.833 24C27.9376 24 28.833 23.1046 28.833 22L28.833 8C28.833 6.89543 27.9376 6 26.833 6L6.83301 6C5.72844 6 4.83301 6.89543 4.83301 8L4.83301 22C4.83301 23.1046 5.72844 24 6.83301 24Z",
    stroke: "#E85D04",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.833 28H12.833",
    stroke: "#E85D04",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.833 15L14.833 11V19L20.833 15Z",
    stroke: "#E85D04",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitorPlay);
export default __webpack_public_path__ + "static/media/MonitorPlay.9b94e559286940e1e93f1721c94b3571.svg";
export { ForwardRef as ReactComponent };